
import React, { useState, useEffect ,useRef} from "react";
import { Link, useParams,useNavigate } from "react-router-dom";
import * as Iconsax from "iconsax-react";
// import { replace, useFormik ,FieldArray,Field,Formik} from 'formik';
import {FieldArray, Field, Form, Formik, FormikProps ,useFormik} from 'formik';

import * as Yup from "yup";
import InputDefault from '../../../components/InputDefault/InputDefault';
import DropdownDefault from "../../../components/DropdownDefault/Dropdown";
import CalendarDefault from "../../../components/CalendarDefault/CalendarDefault";
import Boton from "../../../components/Boton/Boton";
import { ListarEvaluaciones,ListarEvaluacionesUsuario ,RegistrarEvaluaciones, RegistrarCategoriaEvaluacion} from "../../../service/DesarrolloService";
import TextareaDefault from "../../../components/TextArea/TextArea";
import { Dialog } from "primereact/dialog";
import ToastEva from "../../../components/Toast/ToastEva";
import { Toast } from 'primereact/toast';

import BotonEva from '../../../components/Boton/Boton';


const EditarEvaluacion = () => {
    const navigate = useNavigate();
    const [tituloPagina, setTituloPagina] = useState("Editar evaluación de desempeño");
    const [listaEvaluaciones, setListaEvaluaciones] = useState([]);
    const [timeLine, setTimeLine] = useState(null);
    const mesRef = useRef([])
    const calendarRef = useRef([])

    const toast = useRef(null);
    const [showDialog, setShowDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    let today = new Date();
    let year = today.getFullYear();
    const comboMes= [{code: "1",value:"Enero"},
        {code: "2",value:"Febrero"},
        {code: "3",value:"Marzo"},
        {code: "4",value:"Abril"},
        {code: "5",value:"Mayo"},
        {code: "6",value:"Junio"},
        {code: "7",value:"Julio"},
        {code: "8",value:"Agosto"},
        {code: "9",value:"Setiembre"},
        {code: "10",value:"Octubre"},
        {code: "11",value:"Noviembre"},
        {code: "12",value:"Diciembre"}
    ]

    const comboSeguir = 
    [
        {code:"Feedback Evaluacion 1",value:"Feedback Evaluacion 1"},
        {code:"Feedback Evaluacion 2",value:"Feedback Evaluacion 2"},
        {code:"Feedback Evaluacion 3",value:"Feedback Evaluacion 3"},
    ]

    
      const schema = Yup.object().shape({
        sigueAhora: Yup.string().required("Sigue ahora requerido."),
        textoBoton: Yup.string().required("Texto de botón requerido."),
        link: Yup.string().required("Link de botón requerido."),
        evaluaciones: Yup.array()
            .of(
                Yup.object().shape({
                    //idEvaluacion:Yup.string().required("Evaluacion requerida."),
                    descripcion:Yup.string().required("Descripción de Evaluacion requerida."),
                    mesEtapa:Yup.string().required("Mes Requerido."),
                    // fechaFinalizacion : Yup.string().required("Fecha de finalización requerida."),
                    fechaFinalizacion :  Yup.string().when('mesEtapa',(mesEtapa)=>{
                        if(mesEtapa)
                        {
                            let mesSeleccionado = comboMes.filter(x=>x.value == mesEtapa);
                            let month = mesSeleccionado[0].code -1;
                            let year = today.getFullYear();
                            let minDate = new Date();
                            minDate.setDate(1);
                            minDate.setMonth(month);
                            minDate.setFullYear(year);
                            return Yup.date().required("Fecha de finalización requerida.").min(minDate,"No puedes es coger una fecha menor")
                        }                        
                    })
                })
            ).min(1, "Debe Registrar al menos una evaluación")
      });
    /* esv 25-01-25 */
    // Obtiene la lista de evaluaciones disponibles 
    const ObtenerEvaluaciones =async ()=>{
            
            let jwt = window.localStorage.getItem("jwt");
           await ListarEvaluaciones({jwt}).then(data => 
            {
                setListaEvaluaciones(data)
            })
           
        }

    /*useEffect(()=>{        
        ObtenerEvaluaciones();
    },[]) */

    /* end esv 25-01-25 */

    // Carga el detalle de la evaluación para editarla (timeline)
    useEffect(()=>{
        const ObtenerTimeline =async ()=>{
            
            let jwt = window.localStorage.getItem("jwt");
           await ListarEvaluacionesUsuario({jwt}).then(data=>
            {
                let id = data.id; 
                let sigueAhora = data.sigueAhora;
                let textoBoton = data.textoBoton;
                let link = data.link;
                let tipoOperacion = "U"
                let evaluaciones =[]
                data.etapas.map((etapa,i)=>{
                    
                    etapa.evaluaciones.map((evaluacion,j)=>{
                        
                        evaluaciones.push({
                            id:evaluacion.id,
                            //idEvaluacion : evaluacion.idEvaluacion,
                            descripcion : evaluacion.descripcion,
                            mesEtapa : etapa.nombreEtapa,
                            fechaFinalizacion : evaluacion.fechaFinalizacion,
                            //fechaFinalizacion : "1/1/2023",
                            
                            tipoOperacion:"U"
                        });
                    })
                })

                let json = JSON.stringify({id,sigueAhora,textoBoton,link,tipoOperacion,evaluaciones},null,2);

                //alert(json)
                setTimeLine({
                    id:data.id,
                    sigueAhora:data.sigueAhora,
                    textoBoton:data.textoBoton,
                    link:data.link,
                    tipoOperacion:'U',
                    descripcion : data.descripcion,
                    evaluaciones: evaluaciones
                });
            
            })
           
        }
        ObtenerTimeline();

    },[])

    // Recibe e: El valor seleccionado del combo de mese
    const handleMonth =(e,index)=>{
        // Busca el mes seleccionado en comboMes
        let mesSeleccionado = comboMes.filter(x=>x.value == e.value)
        let today = new Date();
        let month = mesSeleccionado[0].code -1;

        // Fija el año
        let year = today.getFullYear();
        let nextYear = (month === 11) ? year + 1 : year;

        // Calcula la fecha mínima permitida
        let minDate = new Date();
            minDate.setMonth(month);
            minDate.setFullYear(year);

        // Calcula la fecha máxima permitida
        let maxDate = new Date();
            maxDate.setMonth(11);
            maxDate.setFullYear(nextYear);

        // Actualiza el calendario dinámicamente mediante ref
        calendarRef.current[index].props.minDate = minDate;
        calendarRef.current[index].props.maxDate = maxDate;
        calendarRef.current[index].props.viewDate = minDate        
    }

    /* esv 25-01-25 */
    /*const footerSeccion = 
    <div style={{display:"flex",justifyContent:"center",width:"100%"}}>
        <BotonEva nombre={"Cancelar"} widths="50%" color="secondary" metodoClick={()=>setShowDialog(false)}></BotonEva>
        <BotonEva nombre={"Registrar"} widths="50%" color="primary" 
        loading = {isLoading}></BotonEva>
    </div>;

    const formikCategoria = useFormik({
            enableReinitialize:true,
            initialValues: {
                nombreEvaluacion:""
            },
            onSubmit: values => {
    
                //console.log("jsonSeccionnnn")
                let nombreEvaluacion = values.nombreEvaluacion
                let jsonEvaluacion = JSON.stringify({ nombreEvaluacion});
    
                console.log("jsonEvaluacion",jsonEvaluacion)
                
            RegistrarCategoriaEvaluaciones({jsonEvaluacion})  
          },
        });
    
        const RegistrarCategoriaEvaluaciones =({jsonEvaluacion})=>{
            let jwt = window.localStorage.getItem("jwt");
            RegistrarCategoriaEvaluacion({jsonEvaluacion,jwt}) // <-- AQUÍ SE ENVÍA AL BACKEND
                .then(data=>{
                    formikCategoria.setSubmitting(false)
                    toast.current?.show({severity:'success', summary: 'Success', detail:"Se añadio exitosamente.", life: 7000})
                    
                    ObtenerEvaluaciones();
                    setShowDialog(false)
            })
            .catch(errors => {
                toast.current?.show({severity:'error', summary: 'Error', detail:errors.message, life: 7000})
                formikCategoria.setSubmitting(false)
                setShowDialog(false)
        
            })
        }

    const Registrar =({jsonCapacitacion})=>{
            let jwt = window.localStorage.getItem("jwt");
            RegistrarCategoriaEvaluacion({jsonCapacitacion,jwt}).then(data=>{
                //formik.setSubmitting(false)
                toast.current?.show({severity:'success', summary: 'Success', detail:"Registro exitoso.", life: 7000})
    
                setShowDialog(false)
                setTimeout(() => {
                    navigate(-1);
                }, 3000)            
            })
            .catch(errors => {
                toast.current?.show({severity:'error', summary: 'Error', detail:errors.message, life: 7000})
                setShowDialog(false)
            })
    } */
    /* end esv 25-01-26*/

    return ( 
        // Estructura visual de la pantalla
        <div className="eva-dashboard-editarEvaluacion">
            <div className="eva-dashboard-header">
                <div>
                    <i href="#" onClick={() => navigate(-1)} className="p-eva-icon-atras">
                        <Iconsax.ArrowLeft color="#000000" />
                    </i>
                </div>
                <div>
                    <label>{tituloPagina}</label>
                </div>
            </div>  

            <div className="eva-dashboard-body">                
                    {/* Inicializa el formulario Formik */}
                    <Formik
                        enableReinitialize={true}

                        //  Si timeLine tiene datos Entonces significa que es editar, y Formik carga:     // Si timeLine es null (primera vez) carga datos vacios
                        initialValues={timeLine ?timeLine:{    
                                            id:0,
                                            sigueAhora:'',
                                            textoBoton:'',
                                            link:'',
                                            tipoOperacion:'A',
                                            descripcion:'',
                                            evaluaciones: [
                                                {
                                                    id : 0,
                                                    //idEvaluacion: '',
                                                    descripcion: '',
                                                    mesEtapa: '',
                                                    fechaFinalizacion: '',
                                                    tipoOperacion:'A'
                                                },
                                            ] }}
                        // Valida
                        validationSchema={schema}
                        
                        // al Presionar Guardar
                        onSubmit={(values, actions) => {
                            
                            /*const payload = {
                                ...values,
                                evaluaciones: values.evaluaciones.map(ev => {
                                if (ev.tipoOperacion === "A") {
                                    const { idEvaluacion, ...rest } = ev;
                                    return rest;
                                }
                                return ev;
                                })
                            };*/

                            //alert(JSON.stringify(values))
                            let jwt = window.localStorage.getItem("jwt");

                            let jsonEvaluacion = JSON.stringify(values)   // Convierte los valores del formulario a JSON:

                            RegistrarEvaluaciones({jsonEvaluacion,jwt}).then(data=> navigate(-1))
                        
                        }}
                    >
                        {({ values ,handleSubmit,handleChange,handleBlur,errors,touched}) => (

                            <form onSubmit={handleSubmit}>
                                 <div className="p-fluid formgrid grid ">
                                    <div className="field col-12 md:col-12">
                                        <label htmlFor="descripcion" className="p-eva-labelForm">
                                            Añade una descripción
                                        </label>
                                        <TextareaDefault
                                            id="descripcion"
                                            minHeight={180}
                                            placeholder="Escribe aquí"
                                            className="White"
                                            value={values.descripcion}
                                            icon={<Iconsax.DocumentText1 />}
                                            name="descripcion"
                                            onChange={handleChange}
                                            onblur={handleBlur}
                                        />
                                    </div>
                                 </div>
                                <FieldArray name="evaluaciones">
                                    {({ insert, remove, push }) => (
                                        <div>                                        
                                            {values.evaluaciones&&
                                                values.evaluaciones.length >0 &&
                                                    values.evaluaciones.map((item,index)=>(
                                                        <div className="p-fluid formgrid grid editarEvaluacion-lista-evaluaciones" key={index}>
                                                            <div className="field col-12 md:col-4" >
                                                                <label htmlFor={`evaluaciones.${index}.mesEtapa`}>Seleccione el mes</label>
                                                                <Field
                                                                    name={`evaluaciones.${index}.mesEtapa`} 
                                                                    >
                                                                    {({
                                                                        field, // { name, value, onChange, onBlur }
                                                                        form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                                                        meta,
                                                                        }) => (
                                                                            <>
                                                                            {console.log(field)}
                                                                                <DropdownDefault 
                                                                                    key={item}
                                                                                    placeholder="Selecciona"
                                                                                    errorClass={meta.touched && 
                                                                                        (meta.error ? "error" : "success")}  
                                                                                    options={comboMes} optionLabel="value"
                                                                                    ref={(e)=>mesRef.current[index]=e}

                                                                                   
                                                                                    {...field}

                                                                                    onChange={(e)=>(field.onChange(e),handleMonth(e,index))}
                                                                                />
                                                                                <p className="error">{meta.error && meta.touched    && meta.error}</p>

                                                                            </>
                                                                            
                                                                        )}

                                                                </Field>
                                                            </div>
                                                            <div className="field col-12 md:col-3" >
                                                                {/* 
                                                                <label htmlFor={`evaluaciones.${index}.idEvaluacion`}>Seleccione la evaluación</label>
                                                                <Field
                                                                    name={`evaluaciones.${index}.idEvaluacion`} 
                                                                    >
                                                                    {({
                                                                        field, // { name, value, onChange, onBlur }
                                                                        form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                                                        meta,
                                                                        }) => (                                                                            
                                                                            <>                                                                            
                                                                            <DropdownDefault 
                                                                                placeholder="Selecciona"
                                                                                errorClass={meta.touched && 
                                                                                        (meta.error ? "error" : "success")}  
                                                                                options={listaEvaluaciones} optionLabel="nombre" optionValue="id"
                                                                                {...field}
                                                                            />
                                                                                <p className="error">{meta.error && meta.touched    && meta.error}</p>

                                                                            </>                                                                            
                                                                        )}
                                                                </Field>   */}
                                                                <label 
                                                                    htmlFor={`evaluaciones.${index}.descripcion`}
                                                                    style={{ color:"#F47647", fontWeight:600 }}
                                                                >
                                                                    Añade descripción de la evaluación
                                                                </label>

                                                                <Field name={`evaluaciones.${index}.descripcion`}>
                                                                    {({ field, meta }) => (
                                                                        <>
                                                                            <InputDefault
                                                                                id={`evaluaciones.${index}.descripcion`}
                                                                                name={`evaluaciones.${index}.descripcion`}
                                                                                className="white"
                                                                                placeholder="Escribe aquí"
                                                                                value={field.value}
                                                                                onChange={field.onChange}
                                                                                onBlur={field.onBlur}
                                                                                errorClass={meta.touched && (meta.error ? "error" : "success")}
                                                                            />

                                                                            <p className="error">
                                                                                {meta.error && meta.touched && meta.error}
                                                                            </p>
                                                                        </>
                                                                    )}
                                                                </Field> 
                                                            </div>
                                                            {/* 
                                                            <div className="field col-12 md:col-1 p-eva-container-icon">
                                                                                              <div className="p-eva-icon">
                                                                                                   <i style={{ cursor: "pointer" }} onClick={()=> setShowDialog(true)} >
                                                                                                        <Iconsax.Add color="#ffffff"/>
                                                                                                   </i>
                                                                                              </div>                                                       
                                                                                        </div>
                                                            */}

                                                            <div className="field col-12 md:col-4" >
                                                                <label htmlFor={`evaluaciones.${index}.fechaFinalizacion`}>Fecha en la que finaliza la evaluación</label>
                                                                <Field
                                                                    id={`evaluaciones.${index}.fechaFinalizacion`} 
                                                                    name={`evaluaciones.${index}.fechaFinalizacion`}                                                                     
                                                                    >
                                                                    {({
                                                                        field, // { name, value, onChange, onBlur }
                                                                        form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                                                                        meta,
                                                                        }) => (
                                                                            <>                                                                            
                                                                                <CalendarDefault placeholder="dd/mm/aaaa" dateFormat="dd/mm/yy" 
                                                                                    ref={(e)=>calendarRef.current[index]=e}
                                                                                    errorClass={meta.touched && 
                                                                                        (meta.error ? "error" : "success")}  
                                                                                    {...field} 
                                                                                    id={`evaluaciones.${index}.fechaFinalizacion`} 
                                                                                    value={field.value.length > 0&&new Date(field.value)} 
                                                                                    readOnlyInput
                                                                                    ></CalendarDefault>
                                                                                <p className="error">{meta.error && meta.touched    && meta.error}</p>
                                                                            </>                                                                            
                                                                        )}

                                                                </Field>         
                                                            </div>
                                                            <div className="field col-12 md:col-12 p-eva-linkText" style={{justifyContent:"end"}}>

                                                                <i style={{cursor:"pointer"}} onClick={()=>{
                                                                    remove(index)
                                                                }}>Eliminar</i>
                                                            </div>
                                                            {index != values.evaluaciones.length-1 && <div className="field col-12 md:col-12" style={{height:2,background:"#000000",opacity:0.1,marginTop:10}}></div>}
                                                        </div>
                                                        
                                                    ))
                                            }
                                            <div className="p-eva-linkText" style={{display:"flex",justifyContent:"end"}}>
                                                <i style={{cursor:"pointer"}} onClick={() => push({
                                                            id : 0,
                                                            //idEvaluacion: '',
                                                            descripcion: '',
                                                            mesEtapa: '',
                                                            fechaFinalizacion: '',
                                                            tipoOperacion:'A'
                                                        })}>Añadir más</i>
                                            </div>
                                            <div style={{height:2,background:"#000000",opacity:0.1,marginTop:24,marginBottom:24}}></div>

                                        </div>
                                    )}
                                </FieldArray>
                                
                                <div className="editarEvaluacion-sigueAhora">
                                    <div className="p-fluid formgrid grid ">
                                        <div className="field col-12 md:col-12" >
                                            <label htmlFor="sigueAhora">Sigue ahora</label>
                                            {/* <DropdownDefault id="sigueAhora" name="sigueAhora" options={listaEvaluaciones} optionLabel="nombre" optionValue="nombre"
                                            errorClass={touched.sigueAhora != undefined&& (errors.sigueAhora?"error":"success")} placeholder="Seleccione" 
                                            value={values.sigueAhora} onChange={handleChange} onblur={handleBlur}/>
                                            <p className="error">{errors.sigueAhora && touched.sigueAhora && errors.sigueAhora}</p> */}
                                            <InputDefault id="sigueAhora" name="sigueAhora" className="white" placeholder="Escribe aquí"
                                            errorClass={touched.sigueAhora != undefined && (errors.sigueAhora ? "error" : "success")} 
                                            value={values.sigueAhora} onChange={handleChange} onBlur={handleBlur} />
                                            <p className="error">{errors.sigueAhora && touched.sigueAhora && errors.sigueAhora}</p>
                                        </div>
                                        <div className="field col-12 md:col-4" >
                                            <label htmlFor="textoBoton" className="p-eva-labelForm">Escribe el texto del boton</label>
                                            <InputDefault id="textoBoton" name="textoBoton" className="white" placeholder="Escribe aquí"
                                            errorClass={touched.textoBoton != undefined && (errors.textoBoton ? "error" : "success")} 
                                            value={values.textoBoton} onChange={handleChange} onBlur={handleBlur} />
                                            <p className="error">{errors.textoBoton && touched.textoBoton && errors.textoBoton}</p>
                                        </div>
                                        <div className="field col-12 md:col-4" >
                                            <label htmlFor="link" className="p-eva-labelForm">Insertar link</label>
                                            <InputDefault id="link" name="link" className="white" placeholder="Escribe aquí"
                                            errorClass={touched.link != undefined && (errors.link ? "error" : "success")} 
                                            value={values.link} onChange={handleChange} onBlur={handleBlur} />
                                            <p className="error">{errors.link && touched.link && errors.link}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="editarEvaluacion-footer">
                                    <Boton nombre={"Cancelar"} color="secondary" widths="184px" metodoClick={()=>navigate(-1)}></Boton>
                                    <Boton nombre={"Actualizar"} color="primary" type="submit" widths="184px"></Boton>
                                </div>
                            </form>
                        )}
                    </Formik>
            </div>

            {/* <Dialog visible={showDialog} onHide={() => {setShowDialog(false); formikCategoria.setFieldValue("nombreEvaluacion", "")}} 
                         footer={<></>} >
                             <div className="eva-header">Añadir Categoría</div>
                            <form  onSubmit={formikCategoria.handleSubmit}>
                                <div>
                                    <div>
                                        <label htmlFor="nombreEvaluacion">Nombre </label>
                                        <InputDefault
                                            id="nombreEvaluacion"
                                            className="white"
                                            placeholder="Escribe aquí"
                                            errorClass={formikCategoria.touched.nombreEvaluacion != undefined && (formikCategoria.errors.nombreEvaluacion ? "error" : "success")}
                                            value={formikCategoria.values.nombreEvaluacion}
                                            onChange={formikCategoria.handleChange}
                                            onBlur={formikCategoria.handleBlur}
                                            name="nombreEvaluacion"
                                        />
                                        <p className="error">{formikCategoria.errors.nombreEvaluacion && formikCategoria.touched.nombreEvaluacion && formikCategoria.errors.nombreEvaluacion}</p>
                                    </div>
            
                                    <div className="p-eva-footer-form d-flex justify-content-center">
                                        <BotonEva nombre={"Cancelar"} color="secondary" widths="184px" metodoClick={() => {setShowDialog(false); formikCategoria.setFieldValue("nombreEvaluacion", "")}}></BotonEva>
                                        
                                        <BotonEva nombre={"Grabar"} color="primary" widths="184px" type="submit" loading={formikCategoria.isSubmitting}></BotonEva>
                                    </div>
                                </div>
                            </form>
            </Dialog> */}

        </div>
     );
}
 
export default EditarEvaluacion;